<template>
  <Header />
  <router-view />
  <ScrollToTop />
  <Footer />
</template>
<script>
  import Header from './components/Header.vue';
  import Footer from './components/Footer.vue';
  import ScrollToTop from './components/ScrollTop.vue';
  // @ is an alias to /src

  export default {
    components: {
      Header,
      ScrollToTop,
      Footer
    },
    computed: {
      isHeaderVisible() {
        return this.$route.name !== 'Home';
      },
    },
  
  };
</script>
<style lang="scss">
@import "./assets/styles.scss";
</style>